module.exports = __webpack_public_path__ + "img/auditIcon.7ef10058.png";